import { TaskQL, TaskNote, ContractNote } from './../../providers/tasks/models';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TasksProvider } from '../../providers/tasks/tasks';
import { UtilsProvider } from '../../providers/utils/utils';

/**
 * Generated class for the TaskNotesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-task-notes',
  templateUrl: 'task-notes.html'
})
export class TaskNotesPage {
  private task: TaskQL;
  private taskNotes: TaskNote[];
  private contractNotes: ContractNote[];
  private newNote: string = '';
  public notePlaceholder: string = 'Add New Note';
  private notePrepend: string;
  public customNote: boolean = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private tasksProvider: TasksProvider,
    private utilsProvider: UtilsProvider,
    ) {
    this.task = this.navParams.get('task');
    let extras = this.navParams.get('extras');
    if(extras.bookingDelayed) {
      this.customNote = true;
      this.notePlaceholder = 'Add Delay Reason';
      this.notePrepend = 'Booking Delay: ';
    }
    if(extras.customerContact) {
      this.customNote = true;
      this.notePlaceholder = 'Add Customer Contact Note';
      this.notePrepend = 'Contact Customer: ';
    }
    if(!this.customNote) this.initNotes();
  }
  initNotes(){
    this.taskNotes = this.task.notes
      ? this.task.notes.sort((a, b) => {
          let atime = Number(a.timestamp);
          let btime = Number(b.timestamp);
          if (btime < atime) {
            return -1;
          } else if (btime > atime) {
            return 1;
          } else {
            return 0;
          }
        })
      : null;

    this.taskNotes = this.utilsProvider.fixImgUrls(this.taskNotes);
    this.contractNotes = this.task?.contractReference?.notes.filter(note => {
      return (
        !note.deleted_ts &&
        (!this.task || (this.task && note.service === this.task.service))
      );
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TaskNotesPage');
  }

  submit(){
    const submitNote = this.notePrepend ? this.notePrepend + this.newNote.trim(): this.newNote.trim();
    this.tasksProvider.addNote(this.task, submitNote).subscribe(response => {

      if(response.notes.length > 0){
        this.task = response;
        this.newNote = "";
        this.navCtrl.getPrevious().data.taskNewNote = this.task;
        if(this.customNote) this.navCtrl.pop();
        this.initNotes();
      }

    })
  }

  disableSubmitTask(){
    if(this.newNote.trim() === '' || this.newNote === undefined) return true;
  }

  getNote(note: string) {
    const regexImg: RegExp = /(https?:\/\/[^\"]+)/g;
    const regexLink: RegExp = /(<a.*?>.*?<\/a>)/g;

    const images: string[] = note.match(regexImg);
    let imageOutput = '';
    if (images && images.length >= 0) {
      imageOutput += '<div class="image-note-container">';
      for (let i = 0; i < images.length; i++) {
        const img = images[i];
        imageOutput += '<div class="note-img"><a href="' + img + '" target="_blank"><img src="' + img + '" alt="note" /></a></div>';
      }
      imageOutput += '</div>';
      note = note.replace(regexLink, '');
    }
    return note + '<br>' + imageOutput;
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-notes/task-notes.ts